/**
 * F-89 (174): why a strike pass did not check a page, in words, for the run's screen. The codes are the ones the
 * worker writes (api/src/reading/strike.ts uncheckedRow, page-image.ts's skips), without their "strike_" prefix, as
 * reading_strike_unchecked() sums them. Never shown as a raw code unless it is one this table does not know.
 */
const WORDS: Record<string, string> = {
  page_has_identifier: 'held an identity number (never sent)',
  page_limit: 'past the page limit',
  throttled: 'the model was too busy (taken again by a later pass)',
  check_failed: 'the check failed (taken again by a later pass)',
  render_failed: 'the page could not be turned into a picture',
  render_blank: 'the page came out blank though it has text',
  no_image: 'no picture on the page (a typed page; an earlier pass could not draw one)',
  image_small: 'the picture is too small',
  image_cmyk: 'the picture is in print colours (CMYK)',
  unreadable_pdf: 'the file could not be read as a PDF',
  no_page: 'the page is not in the file',
  not_pdf: 'the file is not a PDF',
};
const CODINGS: Record<string, string> = {
  ccitt: 'fax', jbig: 'JBIG2', jpx: 'JPEG 2000', raw: 'uncompressed', lzw: 'LZW', runlength: 'run-length', other: 'another',
};

export function strikeReasonWords(code: string): string {
  if (WORDS[code]) return WORDS[code];
  const m = /^image_([a-z]+)$/.exec(code);
  if (m && CODINGS[m[1]!]) return `a picture coded as ${CODINGS[m[1]!]} (an earlier pass could send only a JPEG)`;
  return code;
}

/** "Pages not checked: 3, a picture coded as fax ...; 1, past the page limit", or '' when none. */
export function uncheckedLine(rows: readonly { reason: string; pages: number }[]): string {
  const shown = rows.filter((r) => r.pages > 0);
  if (shown.length === 0) return '';
  return `Pages not checked: ${shown.map((r) => `${r.pages}, ${strikeReasonWords(r.reason)}`).join('; ')}`;
}
